import type { Theme } from "ag-grid-community";
import { iconOverrides, iconSetAlpine, themeQuartz } from "ag-grid-community";

import { iconDataUrl } from "../../icons/iconMarkup.ts";
import { menuCheckIconPart } from "./menuCheckIcon";

// Its checkboxes and radios are drawn by styles/helpers/checkable.scss, like every other one in the app.
const quartzWithoutCheckboxes = themeQuartz.withoutPart("checkboxStyle");

export function createGridTheme(accentColor: string): Theme {
  return quartzWithoutCheckboxes
    .withPart(iconSetAlpine)
    .withPart(
      iconOverrides({
        type: "image",
        icons: {
          menuAlt: { url: iconDataUrl("phosphor/dots-three-vertical") },
          sortAscending: { url: iconDataUrl("phosphor/arrow-up") },
          sortDescending: { url: iconDataUrl("phosphor/arrow-down") },
          none: { url: iconDataUrl("phosphor/broom") },
          pin: { url: iconDataUrl("phosphor/push-pin") },
          autosize: { url: iconDataUrl("phosphor/split-horizontal") },
          autosizeall: { url: iconDataUrl("phosphor/text-columns") },
          reset: { url: iconDataUrl("phosphor/arrows-counter-clockwise") },

          hidecolumn: { url: iconDataUrl("phosphor/eye") },
          expandall: { url: iconDataUrl("phosphor/arrows-out-line-vertical") },
          collapseall: { url: iconDataUrl("phosphor/arrows-in-line-vertical") },
          "small-right": { url: iconDataUrl("phosphor/caret-right") },
          sigma: { url: iconDataUrl("phosphor/sigma") },
          alignLeft: { url: iconDataUrl("phosphor/align-left") },
          sortBy: { url: iconDataUrl("phosphor/arrows-down-up") },
        },
      }),
    )
    .withPart(menuCheckIconPart)
    .withParams({
      borderColor: "#EAEDF0",
      accentColor,
      browserColorScheme: "light",
      fontFamily: { googleFont: "Inter" },
      fontSize: 12,
      headerBackgroundColor: "#F1F1F1",
      headerFontSize: 12,
      headerHeight: 28,
      iconSize: 16,
      rowHeight: 40,
    });
}
